var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIvrMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5732FA",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52695 15.3258L13.0418 15.9775L13.9846 20.6969L11.5435 21.6077C12.1308 23.6903 13.3888 25.5209 15.1225 26.8158L16.8478 24.8634L20.9156 27.4354L20.2639 30.9502C20.1775 31.4163 19.9094 31.829 19.5188 32.0975C19.1281 32.366 18.6467 32.4682 18.1806 32.3818C14.7916 31.538 11.8286 29.4831 9.85065 26.6047C7.87267 23.7264 7.01651 20.2237 7.4437 16.7574C7.53012 16.2913 7.79815 15.8786 8.18883 15.6102C8.57952 15.3417 9.06086 15.2394 9.52695 15.3258Z",
    stroke: "#8833FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9307 9.71436C18.9307 8.99447 19.2166 8.30406 19.7257 7.79502C20.2347 7.28598 20.9252 7 21.6451 7C22.365 7 23.0554 7.28598 23.5644 7.79502C24.0735 8.30406 24.3595 8.99447 24.3595 9.71436V14.2383C24.3595 14.9582 24.0735 15.6486 23.5644 16.1577C23.0554 16.6667 22.365 16.9527 21.6451 16.9527C20.9252 16.9527 20.2347 16.6667 19.7257 16.1577C19.2166 15.6486 18.9307 14.9582 18.9307 14.2383V9.71436Z",
    stroke: "#8833FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.0928C17 14.7477 17.2366 16.6025 18.1143 17.7727C18.992 18.9429 20.4388 19.3327 21.68 19.3327C22.9212 19.3327 24.2938 18.9429 25.1714 17.7727C26.0491 16.6025 26.36 14.7477 26.36 13.0928",
    stroke: "#8833FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9307 23.0459L24.4278 23.0459",
    stroke: "#8833FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7544 19.3838V23.0029",
    stroke: "#8833FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7407 22.4131V28.8408L32.9997 25.6269L27.7407 22.4131Z",
    stroke: "#8833FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvrMenuIcon);
export default __webpack_public_path__ + "static/media/ivr-menu-icon.22e0969975bf8152bf516ce4a5fa2adc.svg";
export { ForwardRef as ReactComponent };